var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconContactUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.05 30.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-contact-us") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.52,17.55,43.51.07A1.86,1.86,0,0,0,43.17,0H1.88a1.94,1.94,0,0,0-.33.07Z",
    fill: "#d04464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.05,1.88a2.06,2.06,0,0,0-.11-.56L30.06,13.71,45,28.61a1.71,1.71,0,0,0,.09-.45Z",
    fill: "#d04464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.12,1.32A1.75,1.75,0,0,0,0,1.88V28.16a1.4,1.4,0,0,0,.1.45L15,13.71Z",
    fill: "#d04464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.62,14.92l-5.49,4.57a.94.94,0,0,1-.61.22.88.88,0,0,1-.59-.22l-5.49-4.57-15,15a1.79,1.79,0,0,0,.46.09H43.17a1.71,1.71,0,0,0,.46-.09Z",
    fill: "#d04464"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactUs);
export default __webpack_public_path__ + "static/media/icon-contact-us.f7b126be4fd544709d563d8708bfd22e.svg";
export { ForwardRef as ReactComponent };